import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_seller_store_layout_instance_hdr_RowInterface,
  bl_mkp_seller_store_layout_instance_hdr_RowClass,
} from "../../dbschema/index";

export class MkpLayoutInstanceContainerModel extends BaseContainerModel {
  bl_mkp_seller_store_layout_instance_hdr: bl_mkp_seller_store_layout_instance_hdr_RowInterface = new bl_mkp_seller_store_layout_instance_hdr_RowClass();
} 
